/* NDC: pagina de produs – actualizare la schimbarea variantei, bară fixă, derulare spre personalizator. */
import { StandardEvents } from '@shopify/events';

// 1. Blocurile NDC dependente de variantă (badge, livrare, preț în bara fixă)
const picker = document.querySelector('variant-picker');
const mainSection = picker?.closest('.shopify-section');
mainSection?.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise
    ?.then(({ detail }) => {
      const html = detail?.html;
      if (!html) return;
      document.querySelectorAll('[data-ndc-refresh]').forEach((el) => {
        const fresh = html.querySelector(`[data-ndc-refresh="${el.dataset.ndcRefresh}"]`);
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    })
    .catch(() => {});
});

// 2. Butoanele „Personalizează / Cumpără acum” duc la personalizator
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ndc-scroll]');
  if (!link) return;
  const target = document.getElementById('ndc-perso');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const first = target.querySelector('[data-ndc-street]');
  if (first && !first.value) setTimeout(() => first.focus({ preventScroll: true }), 450);
});

// 3. Bara fixă apare după ce clientul a trecut de personalizator și de butoanele de comandă
const sticky = document.querySelector('[data-ndc-sticky]');
const perso = document.getElementById('ndc-perso');
if (sticky && perso && 'IntersectionObserver' in window) {
  const buy = mainSection?.querySelector('.add-to-cart-button') || perso;
  const seen = new Map();
  const update = () => {
    const anyVisible = [...seen.values()].some(Boolean);
    const passed = perso.getBoundingClientRect().bottom < 0 || perso.getBoundingClientRect().top > window.innerHeight;
    sticky.hidden = anyVisible || !passed;
    document.body.classList.toggle('ndc-sticky-on', !sticky.hidden);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => seen.set(e.target, e.isIntersecting));
    update();
  });
  [perso, buy].forEach((el) => io.observe(el));
}